import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import React, { Fragment, useMemo, useState } from "react";
import { DateFormatTo_MM_DD_YYYY, formateDateString } from "../../utils/DateFormatter";
import { Box, Typography, Button, Select, FormControl, InputLabel, MenuItem } from "@mui/material";
import { ContentLayout } from "../UI/Template/ContentLayout";
import { Leftpart } from "../UI/Template/Leftpart";
import Sidebar from "../Layout/Sidebar";
import { RightPart } from "../UI/Template/Rightpart";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import WithConditional from "../hoc/WithConditional";
import dayjs from "dayjs";
import classes from "./InternalTrackerScreen.module.css";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TEAMS,REVIEWERSTATUS, ACTIVE, INACTIVE } from "../../constants/miscConstants";
import { useGetInternalTrackerData } from "../../queries/useGetInternalTrackerData";
import Loader from "../UI/Loader";
import { useUpdateInternalTrackerOptions } from "../../queries/useUpdateInternalTrackerOptions";
import { notNullUndefined } from "../../utils/functions";
import { useSnackbar } from "notistack";
import CustomizedSnackbars from "../UI/SnackBar";
import { getMSID, getToken} from "../../authfile";
import AppInsight from "../Azure/AppInsights";


export const InternalTracker = () => {

  const tokenConfig = {
    headers: {
        "Authorization": `Bearer ${getToken()}`,
    },
  };
  const [assignedRole, setAssignedRole] = useState({});
  const [selectionType, setSelectionType] = useState("days");
  const [startDate, setStartDate] = useState(dayjs().subtract(15, 'day'));
  const [endDate, setEndDate] = useState(dayjs(new Date()));
  const [ranges, setRanges] = useState(15);
  const [reviewerTeamList, setReviewerTeamList] = useState([]);
  const [reviewerStatusList, setReviewerStatusList] = useState([]);
  const msid = getMSID();

  const formattedDateStart = startDate ? DateFormatTo_MM_DD_YYYY(startDate) : '';
  const formattedDateEnd = endDate ? DateFormatTo_MM_DD_YYYY(endDate) : '';
  const { enqueueSnackbar } = useSnackbar();

  const { data, isFetching: isFetchingInternalTrackerData, isError: isInternalTrackDataError, error: InternalTrackDataError,refetch } = useGetInternalTrackerData({body: {fromDate: formattedDateStart,toDate: formattedDateEnd},config: tokenConfig});
  const {mutateAsync: updateOptions, isLoading: isUpdatingOptions } = useUpdateInternalTrackerOptions();
  //console.log("the internal tracker data is", data);
  
  const columns = useMemo(
    () => [
      {
          accessorKey: 'msid',
          header: 'MS_ID',
          size: 100
      },
      {
        accessorKey: 'Team', //access nested data with dot notation
        header: 'TEAM',
        Edit: ({ row }) => {
          return (
            <FormControl variant="standard" sx={{ m: 1, minWidth: 80 }}>
              <Select
                value={row.original.Team}
                sx={{fontSize: '0.8rem'}}
                onChange={(event) => {
                  row.original.Team = event.target.value;
                  const item = reviewerTeamList.find(item => item.id === row.original.msid);
                  //console.log("item is", item);
                  if (item !== null && item !== undefined) {
                    setReviewerTeamList(prev => prev.map((eachItem) => {
                      if (eachItem.msid === row.original.msid) {
                        return {
                          ...eachItem,
                          Team: event.target.value
                        }
                      }
                      return eachItem;
                    }))
                  } else {
                    setReviewerTeamList(prev => [
                      ...prev,
                      { id: row.original.msid, Team: event.target.value }
                    ])
                  }
                }}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                renderValue={(selected) => {
                  if (selected === undefined || selected === null) {
                    return <em>Select Team</em>;
                  }

                  return selected || "";
                }}
              >
                <MenuItem disabled value="">
                  <em>Select Team</em>
                </MenuItem>
                {
                  TEAMS.map((eachItem) => <MenuItem sx={{fontSize: '0.8rem'}} value={eachItem}>{eachItem}</MenuItem>)
                }
              </Select>
            </FormControl>
          )
        },
      },
      {
        accessorKey: 'Name', //access nested data with dot notation
        header: 'REVIEWER',
        size: 150,
        enableEditing: false,
      },
      {
        accessorKey: 'Status',
        header: 'STATUS',
        Edit: ({ row }) => {
          return (
            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
              <Select
                value={row.original.Status === 1 ? ACTIVE : INACTIVE}
                sx={{fontSize: '0.8rem'}}
                onChange={(event) => {
                  row.original.Status = event.target.value === ACTIVE ? 1 : 0;
                  const item = reviewerStatusList.find(item => item.id === row.original.msid);
                  if (item !== null && item !== undefined) {
                    setReviewerStatusList(prev => prev.map((eachItem) => {
                      if (eachItem.id === row.original.id) {
                        return {
                          ...eachItem,
                          Status: event.target.value === ACTIVE ? 1 : 0
                        }
                      }
                      return eachItem;
                    }))
                  } else {
                    setReviewerStatusList(prev => [
                      ...prev,
                      { id: row.original.msid, Status: event.target.value === ACTIVE ? 1 : 0 }
                    ])
                  }
                }}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                renderValue={(selected) => {
                  if (selected === undefined || selected === null) {
                    return <em>Select Status</em>;
                  }

                  return selected;
                }}
              >
                <MenuItem disabled value="">
                  <em>Select Status</em>
                </MenuItem>
                {
                  REVIEWERSTATUS.map((eachItem) => <MenuItem sx={{fontSize: '0.8rem'}} value={eachItem}>{eachItem}</MenuItem>)
                }
              </Select>
            </FormControl>
          )
        },
      },
      {
        accessorKey: 'dual_coverage_validation_count', //access nested data with dot notation
        header: 'DUAL COVERAGE VALIDATION',
        size: 200,
        enableEditing: false,
      },
      {
        accessorKey: 'specialized_validation_count', //access nested data with dot notation
        header: 'SPECIALIZED VALIDATION',
        size: 200,
        enableEditing: false,
      },
      {
        accessorKey: 'high_touch_validation_count', //access nested data with dot notation
        header: 'HIGH TOUCH CLIENT VALIDATION',
        size: 200,
        enableEditing: false,
      },
      {
        accessorKey: 'cancel_process_validation_count', //access nested data with dot notation
        header: 'CANCELLATION AND PROCESS VALIDATION',
        size: 200,
        enableEditing: false,
      },
      {
        accessorKey: 'current_day_count', //access nested data with dot notation
        header: 'DAILY',
        size: 50,
        enableEditing: false,
      },
      {
        accessorKey: 'current_week_count', //access nested data with dot notation
        header: 'WEEKLY',
        size: 50,
        enableEditing: false,
      },
      {
        accessorKey: 'current_year_count', //access nested data with dot notation
        header: 'YTD TOTAL',
        size: 50,
        enableEditing: false,
      },
      {
        accessorKey: 'errorCount', //access nested data with dot notation
        header: '# OF ERRORS',
        size: 50,
        enableEditing: false,
      },
      {
        accessorKey: 'reworkCount', //access nested data with dot notation
        header: '# OF REWORKS',
        size: 50,
        enableEditing: false,
      },

    ],
    [reviewerStatusList, reviewerTeamList],
  );

  const handleSaveUsers = () => {
      let combineStatusTeam = {};
      reviewerStatusList.map(each => {
        combineStatusTeam[each.id] = {...combineStatusTeam[each.id],Status: each.Status}
      })
      reviewerTeamList.map(each => {
        combineStatusTeam[each.id] = {...combineStatusTeam[each.id],Team: each.Team}
      })

      let teamString = "", statusString = "", msidString = "",payload = {};
      for(const x in combineStatusTeam){
        //console.log("x is",x);
        teamString+=(notNullUndefined(combineStatusTeam[x].Team)? combineStatusTeam[x].Team : "")+",";
        statusString+=(notNullUndefined(combineStatusTeam[x].Status) ? combineStatusTeam[x].Status : "")+",";
        msidString+=x+","
      }

      // console.log("combine Status Team", combineStatusTeam);
      // console.log("teamString", teamString);
      // console.log("statusString",statusString);

      if(reviewerStatusList.length !== 0 && reviewerTeamList.length !== 0){
        payload = {
          key: 1,
          team: `\"${teamString.slice(0,-1)}\"`,
          status: `\"${statusString.slice(0,-1)}\"`,
          msid: `\"${msidString.slice(0,-1)}\"`,
        }
      }else if(reviewerTeamList.length !== 0){
        payload = {
          key: 2,
          team: `\"${teamString.slice(0,-1)}\"`,
          status: `\"${statusString.slice(0,-1)}\"`,
          msid: `\"${msidString.slice(0,-1)}\"`,
        }
      } else if(reviewerStatusList.length !== 0){
        payload = {
          key: 3,
          team: `\"${teamString.slice(0,-1)}\"`,
          status: `\"${statusString.slice(0,-1)}\"`,
          msid: `\"${msidString.slice(0,-1)}\"`,
        }
      }
      const res = updateOptions({body: payload, config: tokenConfig});
      res.then((message) => {
        if(message.data.status == 1){
          enqueueSnackbar("Assignment is successful",{
            variant: 'success'
          });
          setReviewerStatusList([]);
          setReviewerTeamList([]);
        }else if(message.data.error){
          throw(new Error(message.data.message))
        }
      }).catch((err) => {
        enqueueSnackbar(`something went wrong ${err.message}`,{
      variant: 'error'
      });
      AppInsight.trackEvent({ name: `RQA => Updating Team,status Options Error, msid=> ${msid}`, properties: { errorMessage: "Something went wrong in Updating Team,status options" } });
        
    });
  }

  const calculateDays = (days) => {
    const start = new Date();
    start.setDate(start.getDate() - days);
    // console.log('start is', start);
    return start;
  }

  const handleSelectionChange = (e) => {
    setSelectionType(e.target.value);
    if (e.target.value === "days") {
      handleChange({ target: { value: 90 } })
    }
  };


  const handleChange = (event) => {
    const selectedRange = parseInt(event.target.value, 10);
    setRanges(selectedRange);
    //console.log("start Date in handleChange", calculateDays(selectedRange));
    setStartDate(calculateDays(selectedRange));
    setEndDate(dayjs(new Date()));
  }

  const table = useMaterialReactTable({
    columns: columns,
    data: data || [], //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    editDisplayMode: 'table', // ('modal', 'row', 'cell', and 'custom' are also
    enableEditing: true,
    renderBottomToolbarCustomActions: () => (
      <Box sx={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
        <Button
          color="success"
          variant="contained"
          onClick={handleSaveUsers}
          disabled={
            reviewerStatusList.length === 0 && reviewerTeamList.length === 0
          }
        >
          {Object.keys(assignedRole) !== 0 && 'Save'}
        </Button>

      </Box>
    ),
    renderTopToolbarCustomActions: () => <Fragment>
      <Typography variant="h7" color="primary" sx={{ fontWeight: 'bold', borderBottom: '1px solid #002277' }}>INTERNAL TRACKER SCREEN</Typography>
    </Fragment>
  });

  return (
    <Fragment>
      <WithConditional when={isInternalTrackDataError}>
      <CustomizedSnackbars type="error" API="InternalTrackData  API" message={InternalTrackDataError?.message} />
    </WithConditional>
      <WithConditional when={isFetchingInternalTrackerData || isUpdatingOptions}>
        <Loader message="Loading"/>
      </WithConditional>
      <ContentLayout>
        <Leftpart>
          <Sidebar />
        </Leftpart>
        <RightPart>
          <div className={classes.rowFilters} >

            <div className={classes.dayFilterRight}>
              <FormControl sx={{ mx: 1 }}>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectionType}
                  onChange={handleSelectionChange}
                  sx={{ '& .MuiSelect-select': { padding: '0.5rem ' } }}
                >
                  <MenuItem value="days">Days</MenuItem>
                  <MenuItem value="date">Date</MenuItem>
                </Select>
              </FormControl>
              <WithConditional when={selectionType === "days"}>
                <FormControl sx={{ mx: 1 }}>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={ranges}
                    onChange={handleChange}
                    sx={{ '& .MuiSelect-select': { padding: '0.5rem ' } }}
                  >
                    <MenuItem value={7}>Last 7 Days</MenuItem>
                    <MenuItem value={15}>Last 15 Days</MenuItem>
                    <MenuItem value={30}>Last 30 Days</MenuItem>
                    <MenuItem value={45}>Last 45 Days</MenuItem>
                    <MenuItem value={90}>Last 90 Days</MenuItem>
                  </Select>
                </FormControl>
              </WithConditional>
              <WithConditional when={selectionType === "date"}>
                <div className={classes.startDate}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker label="Start Date"
                      // value={startDate}
                      sx={{
                        display: 'inline-block',
                        '& input': {
                          padding: '8px 14px !important',
                        },

                        '& .MuiInputLabel-root': {
                          marginTop: '-3% !important',
                        }

                      }}
                      onChange={(newValue) => setStartDate(newValue)}
                      format="MM-DD-YYYY"
                    />
                  </LocalizationProvider>
                </div>
                <div className={classes.endDate}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker label="End date"
                      // value={endDate}
                      sx={{
                        display: 'inline-block',
                        '& input': {
                          padding: '8px 14px !important',
                        },
                        '& .MuiInputLabel-root': {
                          marginTop: '-3% !important',
                        }

                      }}
                      onChange={(newValue) => setEndDate(newValue)}
                      format="MM-DD-YYYY"
                    />
                  </LocalizationProvider>
                </div>
              </WithConditional>
              <Button variant='contained' sx={{ mx: 1, backgroundColor: '#002677', padding: '0.5rem' }} className="getResults" onClick={refetch} >Get Results</Button>
            </div>
          </div>
          <MaterialReactTable table={table} />
        </RightPart>
      </ContentLayout>

    </Fragment>
  )
}